import { LocalDate } from '../../../utilities/local-date';

export function getPeriodTimesForDay(period, day) {
  let startTime = period.startTime;
  if (!startTime || LocalDate.fromString(period.start).isBefore(day)) {
    startTime = '00:00';
  }
  let endTime = period.endTime;
  if (!endTime || LocalDate.fromString(period.end).isAfter(day)) {
    endTime = '24:00';
  }
  let unconfirmedText = '';
  if (!period.confirmed) {
    unconfirmedText = ' (ubekreftet)';
  }
  return {
    startTime,
    endTime,
    unconfirmedText,
  };
}
